import React from "react"
import {getCustomerId, getTenantId} from "../../utils/Routes"
import "./Cart.css"
import {useLocation} from "react-router-dom"

const Cart = () => {
	useLocation()

	const iframeSrc = `${
		process.env.REACT_APP_CARE_CART_UI
	}/?shopperId=${getCustomerId()}&tenantId=${getTenantId()}`
	return (
		<div>
			<iframe
				key={iframeSrc}
				src={iframeSrc}
				title="Cart"
				className="cartIframe"
				allow="clipboard-read; clipboard-write"
			/>
		</div>
	)
}

export default Cart
